import React from 'react';
import { useTranslation } from 'react-i18next';
import { closeDialog } from '../../../../store/actionCreators/dialog';
import {useDispatch } from 'react-redux';
import { joinUnionRequest } from "../../../../store/actionCreators/union";


const Confirmation =({unionId}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
 
    const joinUnion = () => {
        console.log('oops')
        dispatch(joinUnionRequest(unionId));
        dispatch(closeDialog('unionConfirmation'));
    }
    return (
        <React.Fragment>
           <div className={"unionAvatarContainer"}>
            </div>
            <div className = {`unionInfo`}>
                <span>{t('unionEditingContent.label')}</span>
                <p>{t('unionId')}: {unionId}</p>
            </div>
            <div className={`dialogConfirmBox`}>
                <button className="primary" onClick={()=>joinUnion()}>{t('button.apply')}</button>
            </div>
        </React.Fragment>
    );
};

export default Confirmation;